import { ShoppingStepsUrls } from '@ph-shopping/model/shopping-step-urls.model';
import { ShoppingStep, ShoppingStepDefinition } from '@ph-shopping/modules/shopping-stepper';

export const decorateSteps = (steps: ShoppingStepDefinition[]): ShoppingStep[] =>
  steps.map((elem: ShoppingStepDefinition) => ({
    ...elem,
    visited: false,
    valid: false,
    paths: elem.paths ? elem.paths.map((path) => ({ ...path, steps: decorateSteps(path.steps) })) : undefined,
  }));

export const updateStep = (steps: ShoppingStep[], step: ShoppingStep, mask: Partial<ShoppingStep>): ShoppingStep[] => {
  return steps.map((elem: ShoppingStep) =>
    elem.url === step.url
      ? {
          ...elem,
          ...mask,
          paths: elem.paths
            ? elem.paths.map((path) => ({ ...path, steps: updateStep(path.steps as ShoppingStep[], step, mask) }))
            : undefined,
        }
      : {
          ...elem,
          paths: elem.paths
            ? elem.paths.map((path) => ({ ...path, steps: updateStep(path.steps as ShoppingStep[], step, mask) }))
            : undefined,
        }
  );
};

export const invalidateStepsAfter = (
  stepsTree: ShoppingStep[],
  currentSteps: ShoppingStep[],
  index: number
): ShoppingStep[] => {
  let updatedSteps = stepsTree;
  for (let idx = index + 1; idx < currentSteps.length; idx++) {
    updatedSteps = updateStep(updatedSteps, currentSteps[idx], { valid: false, visited: false });
  }

  return updatedSteps;
};

export const toggleAllStepsValidity = (steps: ShoppingStep[], isValid: boolean): ShoppingStep[] => {
  const mask = { valid: isValid, visited: isValid };

  return steps.map((step: ShoppingStep) => {
    const update =
      step.paths && step.paths.length
        ? {
            paths: step.paths.map((path) => ({ ...path, steps: path.steps.map((s) => ({ ...s, ...mask })) })),
            ...mask,
          }
        : { ...mask };

    return {
      ...step,
      ...update,
    };
  });
};

export const blankAllStepUrls = (steps: ShoppingStepDefinition[]): ShoppingStep[] =>
  steps.map((elem: ShoppingStepDefinition) => ({
    ...elem,
    url: ShoppingStepsUrls.Empty,
    visited: true,
    valid: true,
    paths: elem.paths ? elem.paths.map((path) => ({ ...path, steps: decorateSteps(path.steps) })) : undefined,
  }));

export const updateShoppingProgress = (
  stepsTree: ShoppingStep[],
  currentSteps: ShoppingStep[],
  targetIdx: number
): ShoppingStep[] => {
  let updatedSteps = stepsTree;
  currentSteps.forEach((step, idx) => {
    if (idx < targetIdx) {
      updatedSteps = updateStep(updatedSteps, step, { valid: true, visited: true });
    } else if (idx === targetIdx) {
      updatedSteps = updateStep(updatedSteps, step, { visited: true });
    }
  });

  return updatedSteps;
};

export const flattenedSteps = (steps: ShoppingStep[]): ShoppingStep[] => {
  if (!steps) {
    return [];
  }
  let collected: ShoppingStep[] = [];
  for (const step of steps) {
    collected = [...collected, step];
    if (step.paths?.length && step.currentPath) {
      const path = step.paths.find((v) => (v.name as string) === step.currentPath);
      if (path) {
        collected = [...collected, ...path.steps] as ShoppingStep[];
      }
    }
  }

  return collected;
};
